import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeMifidViewDialogMessages.cardTitle',
    defaultMessage:
      'Il questionario MiFID è stato compilato correttamente.\nPuoi procedere con la visualizzazione oppure richiederne la modifica.\nLa modifica del questionario prevede un nuovo appuntamento con il tuo consulente finanziario.',
  },
  cancelCTA: {
    id: 'homeMifidViewDialogMessages.cancelCTA',
    defaultMessage: 'Visualizza',
  },
  confirmCTA: {
    id: 'homeMifidViewDialogMessages.confirmCTA',
    defaultMessage: 'Modifica',
  },
});
